import { useQuery } from "react-query";
import OrderScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useState } from "react";
import { TModal } from "../../../types/common.type";
import utils from "../../../utils";
import {
  ICreateAndUpdateOrder,
  IRequestOrder,
} from "../../../types/order.interface";

const CompanyContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedOrder, setSelectedOrder] = useState<ICreateAndUpdateOrder>();
  const [requestOrder, setRequestOrder] = useState<IRequestOrder>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
  });

  const resultOrder = useQuery(
    [values.useQueryKeys.getAllOrder, requestOrder],
    () =>
      api.postMethod.common.findOrder({
        ...requestOrder,
      })
  );

  const updateOrder = async (OrderInfo: ICreateAndUpdateOrder) => {
    setLoading(true);
    const result = await api.patchMethod.common.updateOrder(OrderInfo);
    if (result) {
      resultOrder.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  // const createOrder = async (OrderInfo: ICreateAndUpdateOrder) => {
  //   setLoading(true);
  //   const result = await api.postMethod.common.createOrder(OrderInfo);
  //   if (result) {
  //     resultOrder.refetch();
  //     setLoading(false);
  //     setShowModal("NONE");
  //     utils?.successHandler(result?.CODE);
  //     return true;
  //   } else {
  //     utils?.errorHandler(result?.CODE);
  //     setLoading(false);
  //     return false;
  //   }
  // };

  return (
    <Context.OrderScreen.Provider
      value={{
        resultOrder,
        requestOrder,
        setRequestOrder,
        showModal,
        setShowModal,
        selectedOrder,
        setSelectedOrder,
        loading,
        setLoading,
        updateOrder,
        // createOrder,
      }}
    >
      <OrderScreen />
    </Context.OrderScreen.Provider>
  );
};

export default CompanyContainer;
